import { IToastProps } from "@blueprintjs/core";
import Survey from "./models/Survey";

export interface SurveyWithExtras extends Survey {
  created_at?: string;
  status?: string;
  locked_time?: string | null;
  created_by?: number;
  created_by_name?: string;
  locked_by_id?: number;
  locked_by_name?: string;
  tags?: number[];
  deleted_at?: string | null;
}

/** A survey is archived (soft-deleted) when deleted_at is set. */
export function isSurveyArchived(
  survey: { deleted_at?: string | null } | null | undefined
): boolean {
  return survey?.deleted_at != null;
}

export interface SinkOrder {
  id: number;
  survey_id: number;
  description: string | null;
  type: string;
  order_type_name?: string | null;
  started: string | null;
  submitted: string | null;
  completed: string | null;
  submitted_by_name?: string | null;
  created_by_name?: string | null;
}

export interface SinkState {
  folders: Array<{ id: number; label: string; level: number }>;
  sites?: Array<{ id: number; label: string }>;
  orders: any[];
  organization?: any;
  materials?: Array<{ id: number; name: string; organization_id?: number; archived?: number | null; inventory: boolean }>;
}

export interface IAppState {
  currentUser: IUser | null;
  errors: string[];

  /*
     `authStatusVerified` means that the server has checked the user's
     session and confirmed that they are not authenticated, in contrast
     to the server not having checked yet.
  */
  authStatusVerified: boolean;

  toasts: IToastProps[];
}

export interface IUser {
  name: string;
}

export interface IAnnotationLayerFields {
  label: string;
}

export interface IAnnotationFields {
  layer_id?: number;
  label?: string;
  description?: string;
  geometry?: string | { [key: string]: any };
  properties?: { [key: string]: any };
  attributes?: { [key: string]: any };
  color?: string;
  material_id?: number;
}

export interface IAnnotationAttributeFields {
  annotation_id?: number;
  label_id: number;
  value: string;
}
